import styled from "styled-components";
import { THEME } from "../../styles/theme";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const UnitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
  padding: 2rem;
  border-radius: 1.5rem;
  background-color: ${THEME.palette.background.paper};
  overflow-y: auto;
  flex: 1;
`;
